/*
 * The shape every area's `routes.tsx` exports. Areas own their subroutes; the app router (router.tsx) only
 * places each area's lists under the right layout:
 *   shell   inside the app shell (sidebar, top bar, banners): most pages
 *   focus   a quiet full-screen layout with the logo and an exit link: onboarding, wizards, /activate
 *   guest   signed-out only (sign in, sign up); signed-in visitors are sent on
 *   public  no sign-in needed, no layout (link targets, /dev/kit)
 *
 *   // src/features/support/routes.tsx
 *   export const routes: AreaRoutes = {
 *     shell: [
 *       { path: 'support', lazy: page(() => import('./pages/SupportPage')) },
 *       { path: 'support/new', lazy: page(() => import('./pages/NewTicketPage')) },
 *       { path: 'support/:id', lazy: page(() => import('./pages/TicketPage')) },
 *     ],
 *   }
 * Paths are relative (no leading slash). Pages default-export their component. The router discovers every
 * `src/features/<area>/routes.tsx` that exports `routes`, so a new area needs no edit outside its folder.
 */
import type { ComponentType } from 'react'
import type { RouteObject } from 'react-router'

export type AreaRoutes = {
  shell?: RouteObject[]
  focus?: RouteObject[]
  guest?: RouteObject[]
  public?: RouteObject[]
}

/** Lazy route for a page module that default-exports its component (code-split per page). */
export function page(load: () => Promise<{ default: ComponentType }>): RouteObject['lazy'] {
  return async () => ({ Component: (await load()).default })
}
